const date = (value, time = false) => {
  if (!value || !Number.isFinite(new Date(value).getTime())) return '—'
  return new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', year: '2-digit',
    ...(time ? { hour: '2-digit', minute: '2-digit' } : {})
  }).format(new Date(value))
}
const states = {
  pending: 'Aguardando conciliação',
  active: 'Pausado',
  completed: 'Reativado',
  canceled: 'Cancelada',
  legacy: 'Histórico anterior'
}


export function formatSubscriptionPause(subscription = {}) {
  const policy = subscription.pausePolicy
  return {
    pausePolicy: {
      mode: policy?.mode || null,
      cutoffDays: policy?.cutoffDays ?? (policy?.cutoffDate ? 3 : 0),
      eligible: policy?.eligible === true,
      days: policy?.days || 0,
      renewalMonths: policy?.renewalMonths ?? null,
      reason: policy?.reason || (!policy ? 'Disponibilidade de pausa indisponível. Atualize os dados.' : ''),
      availableAt: date(policy?.availableAt, false),
      cutoffDate: policy?.cutoffDate ? policy.cutoffDate.split('-').reverse().join('/') : '—',
      rule: policy?.days
        ? `${policy.days} dias corridos.${policy.renewalMonths ? ` Nova pausa ${policy.renewalMonths} meses após o fim da última pausa.` : ''}`
        : 'Este plano não oferece pausa.'
    },
    pause: subscription.pausa?.pausado ? {
      pending: subscription.pausa.state === 'pending',
      startsAt: date(subscription.pausa.dataPausa, false), endsAt: date(subscription.pausa.dataReativacao, false),
      nextBillingAt: date(subscription.pausa.novaProximaCobranca)
    } : null,
    pauseHistory: (subscription.pauseHistory || []).map(item => ({
      id: item.id, planType: item.planType || '—', days: item.days,
      startedAt: date(item.startedAt, false), endedAt: date(item.endedAt || item.endsAt, false),
      previousBillingAt: date(item.previousBillingAt), nextBillingAt: date(item.nextBillingAt),
      state: states[item.state] || 'Histórico anterior'
    })).reverse()
  }
}
